import { Link } from 'react-router-dom';
import Slider from './Slider'; // new component

export const Header = (props) => {
  return (
    <header id="header">
      <Slider {...props} />
    </header>
  );
};
